/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';



import { useNavigate } from 'react-router-dom';



import { useAuth } from '../hooks/useAuth';



import api from '../services/api';



import MainLayout from '../components/layout/MainLayout';



import AgendaSection from '../components/ui/AgendaSection';



import PointageModule from '../components/shared/PointageModule';

import MarquerFinJournee from '../components/MarquerFinJournee';



import PersonnelManagementModule from '../components/shared/PersonnelManagementModule';



import { TaskManagementModule } from '../components/rh';
import MaPerformance from '../components/rh/MaPerformance';
import PreuvesPanel from '../components/shared/PreuvesPanel';
import ObjectifsEmployesModule from '../components/shared/ObjectifsEmployesModule';
import MesDemandesPermission from '../components/employe/MesDemandesPermission'; // eslint-disable-line no-unused-vars



import useDeptDashboard from '../hooks/useDeptDashboard';
import TaskToggleWithPreuve from '../components/shared/TaskToggleWithPreuve';



import './DashboardDGPage.css';
import { useMobileSidebar } from '../hooks/useMobileSidebar';







const fmtN = n => Math.round(n).toLocaleString('fr-FR');



const fmtK = n => n >= 1000000 ? (n / 1000000).toFixed(1) + 'M' : n >= 1000 ? (n / 1000).toFixed(0) + 'k' : String(n);



const TODAY = new Date().toISOString().slice(0, 10);







// D?partement Location & Immobilier ? adapter l'ID selon ta BDD



const DEPT_ID = 18; // Immobilier (FHC Location)







function Pbar({ pct, color }) {



  const c = color || (pct >= 70 ? '#4caf50' : pct >= 40 ? '#ff9800' : '#ef5350');



  return (



    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



      <div className="pbar-wrap" style={{ flex: 1 }}>



        <div className="pbar-fill" style={{ width: `${pct}%`, background: c }} />



      </div>



      <span style={{ fontSize: 10, color: '#778', width: 28, textAlign: 'right' }}>{pct}%</span>



    </div>



  );



}







function sBdg(s) {



  const m = {



    disponible: ['green', '? Disponible'], loue: ['orange', '🔹 Lou?'],



    en_visite: ['blue', '🗑️ En visite'], paye: ['green', '? Pay?'],



    impaye: ['red', '🔹 Impay?'], retard: ['red', '? Retard'],



    actif: ['green', '? Actif'], CDI: ['gold', 'CDI'], CDD: ['blue', 'CDD'], Stage: ['purple', 'Stage'],



  };



  const [cls, lbl] = m[s] || ['gold', s];



  return <span className={`badge ${cls}`}>{lbl}</span>;



}







function ModalWrap({ title, onSave, onClose, children }) {



  return (



    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>



      <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 28, minWidth: 440, maxWidth: 560, width: '92%', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>



          <span style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>{title}</span>



          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>?</button>



        </div>



        {children}



        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>



          <button className="btn-outline" onClick={onClose}>Annuler</button>
          <button className="btn-gold" onClick={onSave}>Enregistrer</button>



        </div>



      </div>



    </div>



  );



}







const Field = ({ label, name, type = 'text', opts, rows, required, form, setForm }) => {



  const handleChange = (e) => {



    setForm(prev => ({ ...prev, [name]: e.target.value }));



  };







  const s = { width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none' };



  return (



    <div style={{ marginBottom: 12 }}>



      <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>



        {label} {required && <span style={{ color: '#ef8080' }}>*</span>}



      </label>



      {opts



        ? <select 



            style={{ ...s, background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)' }} 



            value={form[name] || ''} 



            onChange={handleChange}



          >



            <option value="">-- choisir --</option>



            {opts.map(o => <option key={o.v || o} value={o.v || o} style={{ background: '#0d1b2a' }}>{o.l || o}</option>)}



          </select>



        : rows



        ? <textarea 



            style={{ ...s, resize: 'vertical' }} 



            rows={rows} 



            value={form[name] || ''} 



            onChange={handleChange}



          />



        : <input 



            style={s} 



            type={type} 



            value={form[name] || ''} 



            onChange={handleChange}



            autoFocus={required && !form[name]}



          />



      }



    </div>



  );



};







function DashboardLocationPage() {
  // eslint-disable-next-line no-undef
  const navigate = useNavigate();
  useMobileSidebar();

  const { logout: authLogout } = useAuth();



  const [activePage, setActivePage] = useState('vue-globale');



  const [now, setNow] = useState(new Date());



  const [projets, setProjets] = useState([]);



  useEffect(() => { api.projects.getAll({ departement_id: DEPT_ID }).then(res => setProjets(res.projects || [])).catch(() => {}); }, []);



  const [modal, setModal] = useState(null);



  const [form, setForm] = useState({});



  const [selectedBien, setSelectedBien] = useState(null);



  const [bienFilter, setBienFilter] = useState('tous');







  // Donn?es immobili?res depuis l'API



  const [biens, setBiens] = useState([]);



  const [proprietaires, setProprietaires] = useState([]);



  const [locataires, setLocataires] = useState([]);



  const [contrats, setContrats] = useState([]);



  const [loyers, setLoyers] = useState([]);



  const [apiLoading, setApiLoading] = useState(true);



  const [apiError, setApiError] = useState(null);







  // Employ?s et t?ches via useDeptDashboard



  const {



    employes, setEmployes,



    tasks, setTasks,



    loading: empLoading, error: empError, refetch,



    toggleTask, deleteTask, createTask,



  } = useDeptDashboard({ deptId: DEPT_ID });







  // Charger les donn?es immobili?res depuis l'API



  useEffect(() => {



    const loadImmo = async () => {



      try {



        setApiLoading(true);



        setApiError(null);







        const [biensRes, loyersRes] = await Promise.allSettled([



          api.location.biens.getAll(),



          api.location.loyers.getAll({ mois: new Date().toISOString().slice(0, 7) }),



        ]);







        if (biensRes.status === 'fulfilled') {



          const list = biensRes.value?.biens || [];



          setBiens(list.map(b => ({



            id: b.id,



            titre: b.titre || `${b.type || 'Bien'} ? ${b.adresse || ''}`,



            type: b.type || 'Appartement',



            zone: b.adresse || b.zone || '?',



            loyer: parseFloat(b.loyer_mensuel || b.loyer) || 0,



            caution: b.caution_mois || 2,



            surface: parseFloat(b.surface) || 0,



            chambres: b.chambres || '?',



            meuble: b.meuble ? 'oui' : (b.meuble === false ? 'non' : b.meuble || 'non'),



            proprio: b.proprietaire?.nom || '?',



            statut: b.statut || 'disponible',



            locataire: b.locataire?.nom || null,



            emoji: b.type === 'Villa' ? '🔹' : b.type === 'Bureau' ? '🗑️' : b.type === 'Commerce' ? '🔹' : b.type === 'Maison' ? '🔹' : b.type === 'Studio' ? '🔹' : '🔹',



            desc: b.description || '?',



          })));



        }







        if (loyersRes.status === 'fulfilled') {



          const list = loyersRes.value?.loyers || [];



          setLoyers(list.map(l => ({



            id: l.id,



            locataire: l.locataire?.nom || '?',



            bien: l.bien?.adresse || l.bien?.titre || '?',



            montant: parseFloat(l.montant) || 0,



            mois: l.mois || '?',



            date: l.date_paiement || null,



            mode: l.mode_paiement || '?',



            statut: l.statut_paiement || l.statut || 'impaye',



          })));



        }







        // Propri?taires et locataires



        const [propRes, locRes] = await Promise.allSettled([



          fetch(`${process.env.REACT_APP_API_URL || 'https://plateforme.fhcgroupesarl.com/api'}/proprietaires`, {



            headers: { Authorization: `Bearer ${localStorage.getItem('fhc_token')}`, Accept: 'application/json' },



          }).then(r => r.ok ? r.json() : { proprietaires: [] }),



          fetch(`${process.env.REACT_APP_API_URL || 'https://plateforme.fhcgroupesarl.com/api'}/locataires`, {



            headers: { Authorization: `Bearer ${localStorage.getItem('fhc_token')}`, Accept: 'application/json' },



          }).then(r => r.ok ? r.json() : { locataires: [] }),



        ]);







        if (propRes.status === 'fulfilled') {



          const list = propRes.value?.proprietaires || [];



          setProprietaires(list.map(p => ({



            id: p.id,



            nom: p.nom || '?',



            tel: p.telephone || '?',



            email: p.email || '?',



            biens: p.biens_count || 0,



            revenusMensuel: parseFloat(p.revenus_mensuels) || 0,



            commission: parseFloat(p.commission) || 10,



            depuis: p.created_at ? new Date(p.created_at).toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }) : '?',



            statut: 'actif',



          })));



        }







        if (locRes.status === 'fulfilled') {



          const list = locRes.value?.locataires || [];



          setLocataires(list.map(l => ({



            id: l.id,



            nom: l.nom || '?',



            tel: l.telephone || '?',



            bien: l.bien?.titre || l.bien?.adresse || '?',



            loyer: parseFloat(l.loyer) || 0,



            caution: parseFloat(l.caution) || 0,



            entree: l.date_entree || '?',



            fin: l.date_fin || '?',



            statut_paiement: l.statut_paiement || 'paye',



          })));



        }







      } catch (err) {



        setApiError(err.message);



      } finally {



        setApiLoading(false);



      }



    };







    loadImmo();



    const interval = setInterval(loadImmo, 60000);



    return () => clearInterval(interval);



  }, []);







  useEffect(() => {



    const t = setInterval(() => setNow(new Date()), 60000);



    return () => clearInterval(t);



  }, []);







  const totalTasks = employes.reduce((sum, emp) => sum + (emp.assignedTasks || []).length, 0);
  const allObj = employes.flatMap(e => e.objectifs || []);

  // 🔹 Filtrer les t?ches du chef connect? pour "Mes t?ches"
  const { user } = useAuth();
  const myTasks = useMemo(() => {
    const userId = user?.id;
    if (!userId) return tasks; // Fallback: afficher toutes si pas d'user
    return tasks.filter(t => t.employee_id === userId);
  }, [tasks, user]);
  const myPendingTasks = myTasks.filter(t => !t.done).length;



  const openModal = useCallback((type, data = {}) => { setForm(data); setModal(type); }, []);



  const closeModal = useCallback(() => { setModal(null); setForm({}); }, []);



  const handleLogout = async () => { await authLogout(); navigate('/auth', { replace: true }); };







  const formattedDate = now.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });







  // KPIs calcul?s depuis les donn?es BDD



  const loues = biens.filter(b => b.statut === 'loue').length;



  const disponibles = biens.filter(b => b.statut === 'disponible').length;



  const moisActuel = now.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });



  const revenusMois = loyers.filter(l => l.statut === 'paye').reduce((s, l) => s + l.montant, 0);



  const impayes = loyers.filter(l => l.statut === 'impaye').length;



  const tauxOcc = biens.length > 0 ? Math.round(loues / biens.length * 100) : 0;



  const pendingTasks = myPendingTasks; // Utiliser myPendingTasks au lieu de filtrer toutes les t?ches



  const presents = employes.filter(e => e.present).length;







  const filteredBiens = bienFilter === 'tous' ? biens : biens.filter(b => b.statut === bienFilter || b.type === bienFilter);







  const F = props => <Field {...props} form={form} setForm={setForm} />;







  // CRUD biens



  const saveBien = async () => {



    if (!form.titre) return;



    const b = {



      id: form._isEdit ? form.id : Date.now(),



      titre: form.titre, type: form.type || 'Appartement', zone: form.zone || 'Cotonou',



      loyer: parseFloat(form.loyer) || 0, caution: parseFloat(form.caution) || 1,



      surface: parseFloat(form.surface) || 0, chambres: form.chambres || '?',



      meuble: form.meuble || 'non', proprio: form.proprio || '?',



      statut: form.statut || 'disponible', locataire: null,



      emoji: form.type === 'Villa' ? '🔹' : form.type === 'Bureau' ? '🗑️' : form.type === 'Commerce' ? '🔹' : form.type === 'Maison' ? '🔹' : form.type === 'Studio' ? '🔹' : '🔹',



      desc: form.desc || '?',



    };



    // Tentative API



    try {



      if (form._isEdit) {



        await fetch(`${process.env.REACT_APP_API_URL || 'https://plateforme.fhcgroupesarl.com/api'}/biens/${form.id}`, {



          method: 'PUT', headers: { Authorization: `Bearer ${localStorage.getItem('fhc_token')}`, 'Content-Type': 'application/json', Accept: 'application/json' },



          body: JSON.stringify({ titre: form.titre, type: form.type, loyer_mensuel: form.loyer, statut: form.statut, description: form.desc }),



        });



      }



    } catch {}



    if (form._isEdit) setBiens(prev => prev.map(x => x.id === b.id ? b : x));



    else setBiens(prev => [...prev, b]);



    closeModal();



  };







  const saveProprio = () => {



    if (!form.nom) return;



    const p = { id: form._isEdit ? form.id : Date.now(), nom: form.nom, tel: form.tel || '?', email: form.email || '?', biens: 0, revenusMensuel: 0, commission: parseFloat(form.commission) || 10, depuis: new Date().toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }), statut: 'actif' };



    if (form._isEdit) setProprietaires(prev => prev.map(x => x.id === p.id ? p : x));



    else setProprietaires(prev => [...prev, p]);



    closeModal();



  };







  const saveLocataire = () => {



    if (!form.nom) return;



    const l = { id: form._isEdit ? form.id : Date.now(), nom: form.nom, tel: form.tel || '?', bien: form.bien || '?', loyer: parseFloat(form.loyer) || 0, caution: parseFloat(form.caution) || 0, entree: form.entree || TODAY, fin: form.fin || '?', statut_paiement: 'paye' };



    if (form._isEdit) setLocataires(prev => prev.map(x => x.id === l.id ? l : x));



    else setLocataires(prev => [...prev, l]);



    closeModal();



  };







  const savePaiement = () => {



    if (!form.locataire || !form.montant) return;



    setLoyers(prev => [...prev, { id: Date.now(), locataire: form.locataire, bien: '?', montant: parseFloat(form.montant) || 0, mois: form.mois || moisActuel, date: new Date().toLocaleDateString('fr-FR'), mode: form.mode || 'Esp?ces', statut: 'paye' }]);



    closeModal();



  };







  const saveEmploye = () => {



    if (!form.prenom || !form.nom) return;



    const e = { id: form._isEdit ? form.id : Date.now(), av: ((form.prenom[0] || '') + (form.nom[0] || '')).toUpperCase(), prenom: form.prenom, nom: form.nom, poste: form.poste || '?', email: form.email || '', password: form.password || '', filiale: form.filiale || '?', contrat: form.contrat || 'CDI', entree: form.entree || new Date().toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }), heureLimite: form.heureLimite || '08:30', arrivee: '?', present: false, color: form.color || '#42a5f5', score: 0, tachesQuot: 0, tachesDone: 0, assignedTasks: [] };



    if (form._isEdit) setEmployes(prev => prev.map(x => x.id === e.id ? e : x));



    else setEmployes(prev => [...prev, e]);



    closeModal();



  };







  const saveTask = async () => {



    if (!form.text) return;



    try {



      await createTask({ titre: form.text, priority: form.prio || 'normale', category: 'Autre' });



    } catch {



      setTasks(prev => [...prev, { id: Date.now(), text: form.text, done: false, prio: form.prio || 'normale', date: TODAY }]);



    }



    closeModal();



  };







  const loading = apiLoading || empLoading;



  const error = apiError || empError;







  return (



    <MainLayout>



      <div className="dashboard-dg-root">







        {/* TOPBAR */}



        <div className="topbar">



          <div className="topbar-left">



            <div className="tlogo" style={{ background: 'linear-gradient(135deg,#1565c0,#0d47a1)' }}>🔹</div>



            <div>



              <div className="tname">FHC Location ? AfricaLocation</div>



              <div className="tsub">Dashboard ? Chef D?partement Location des Biens</div>



            </div>



          </div>



          <div className="topbar-right">



            <div className="tdate">{formattedDate}</div>



            <button className="tbtn" onClick={refetch}>?</button>



            <div style={{ textAlign: 'right' }}>



              <div className="tuser">Chef Location</div>



              <div className="trole" style={{ color: '#64b5f6' }}>🔹 Immobilier (FHC Location)</div>



            </div>



            <div className="tavatar" style={{ background: 'linear-gradient(135deg,#1565c0,#0d47a1)' }}>PL</div>



            <button className="tbtn" onClick={handleLogout} style={{ color: '#ef8080', borderColor: 'rgba(239,83,80,.3)' }}>🔹 D?connexion</button>



          </div>



        </div>







        {/* LAYOUT */}



        <div className="layout">







          {/* SIDEBAR */}



          <div className="sidebar">



            <div className="sb-logo">Immobilier</div>



            {[



              { id: 'vue-globale', icon: '🔹', label: 'Vue globale' },



              { id: 'annonces', icon: '🔹', label: 'Annonces', badge: String(biens.length) },



              { id: 'proprietaires', icon: '🔹', label: 'Propri?taires', badge: String(proprietaires.length) },



              { id: 'locataires', icon: '🔹', label: 'Locataires', badge: String(locataires.length) },



              { id: 'contrats', icon: '🔹', label: 'Contrats de bail', badge: String(contrats.length) },



              { id: 'loyers', icon: '🔹', label: 'Loyers', badge: impayes > 0 ? String(impayes) : '' },



              { id: 'stats', icon: '🔹', label: 'Statistiques' },



              { id: 'personnel', icon: '🔹', label: 'Personnel', badge: String(employes.length), badgeCls: 'green' },



            ].map(it => (



              <div key={it.id} className={`sb-item ${activePage === it.id ? 'active' : ''}`} onClick={() => setActivePage(it.id)}>



                <span className="si">{it.icon}</span><span>{it.label}</span>



                {it.badge && <span className={`sb-badge ${it.id === 'loyers' ? 'red' : ''}`}>{it.badge}</span>}



              </div>



            ))}



            <div className="sb-sep" />



            <div className="sb-logo">?quipe & Pilotage</div>



            {[

              { id: 'mon-equipe', icon: '🔹', label: 'Mon équipe', badge: String(employes.length), badgeCls: 'green' },

              { id: 'ma-performance', icon: '⭐', label: 'Ma Performance' },

              { id: 'gestion-taches', icon: '🔹', label: 'Gestion Tâches', badge: totalTasks > 0 ? String(totalTasks) : '', badgeCls: 'gold' },

              { id: 'objectifs', icon: '🎯', label: 'Objectifs', badge: allObj.filter(o => o.statut === 'atteint').length || null },

              { id: 'taches', icon: '✓', label: 'Mes tâches', badge: String(pendingTasks) },
              { id: 'permissions', icon: '📝', label: 'Mes Permissions' },
              { id: 'agenda', icon: '🔹', label: 'Agenda' },

              { id: 'rapports', icon: '🔹', label: 'Rapports' },

              { id: 'projets', icon: '🔹', label: 'Projets', badge: projets.length > 0 ? String(projets.length) : '' },

            ].map(it => (



              <div key={it.id} className={`sb-item ${activePage === it.id ? 'active' : ''}`} onClick={() => setActivePage(it.id)}>



                <span className="si">{it.icon}</span><span>{it.label}</span>



                {it.badge && <span className={`sb-badge ${it.badgeCls || ''}`}>{it.badge}</span>}



              </div>



            ))}

            <div className="sb-sep" />
            <div className="sb-item" onClick={() => navigate('/documents')}>
              <span className="si">📁</span><span>Documents</span>
            </div>

          </div>







          {/* MAIN */}



          <div className="main">







            {loading && <div style={{ padding: 20, textAlign: 'center', color: '#C9A84C', fontSize: 13 }}>Chargement?</div>}



            {error && !loading && <div style={{ margin: '10px 0', padding: '8px 14px', background: 'rgba(239,83,80,.1)', border: '1px solid rgba(239,83,80,.3)', borderRadius: 8, fontSize: 12, color: '#ef8080' }}>🔹 {error}</div>}







            {/* VUE GLOBALE */}



            <div className={`page ${activePage === 'vue-globale' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">Vue Globale ? Location des Biens</div>



                  <div className="page-sub">AfricaLocation ? {now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</div>



                </div>



                <button className="btn-gold" onClick={() => openModal('bien', { type: 'Appartement', meuble: 'non', caution: '2', statut: 'disponible' })}>+ Ajouter un bien</button>



              </div>







              <PointageModule currentUser={{ nom: 'Chef Location' }} />

              <MarquerFinJournee onSuccess={() => {
                console.log('Fin de journée enregistrée - Dashboard Location');
              }} />





              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{biens.length}</div><div className="kpi-label">Biens en portefeuille</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#66bb6a' }}>{loues}</div><div className="kpi-label">Biens lou?s</div><div className="kpi-trend up">{tauxOcc}% occupation</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#C9A84C' }}>{fmtK(revenusMois)} F</div><div className="kpi-label">Revenus locatifs/mois</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: impayes > 0 ? '#ef5350' : '#4caf50' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: impayes > 0 ? '#ef8080' : '#66bb6a' }}>{impayes}</div><div className="kpi-label">Loyers impay?s</div></div>



              </div>







              <div className="grid2">



                <div className="card">



                  <div className="card-title">🔹 Annonces r?centes



                    <button className="btn-outline" style={{ fontSize: 11, padding: '3px 10px' }} onClick={() => setActivePage('annonces')}>Voir tout ?</button>



                  </div>



                  {biens.length === 0



                    ? <div style={{ padding: '16px 0', textAlign: 'center', color: '#445', fontSize: 12 }}>Aucun bien charg?.</div>



                    : biens.slice(0, 5).map(b => (



                      <div key={b.id} onClick={() => setSelectedBien(b)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.04)', cursor: 'pointer' }}>



                        <span style={{ fontSize: 18 }}>{b.emoji}</span>



                        <div style={{ flex: 1 }}><div style={{ fontSize: 12, fontWeight: 500, color: '#fff' }}>{b.titre}</div><div style={{ fontSize: 9, color: '#556' }}>{b.zone} ? {fmtN(b.loyer)} FCFA/mois</div></div>



                        {sBdg(b.statut)}



                      </div>



                    ))



                  }



                </div>



                <div className="card">



                  <div className="card-title">🔹 Loyers r?cents



                    <button className="btn-outline" style={{ fontSize: 11, padding: '3px 10px' }} onClick={() => setActivePage('loyers')}>Voir tout ?</button>



                  </div>



                  {loyers.length === 0



                    ? <div style={{ padding: '16px 0', textAlign: 'center', color: '#445', fontSize: 12 }}>Aucun loyer charg?.</div>



                    : loyers.slice(0, 5).map(l => (



                      <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                        <div style={{ flex: 1 }}><div style={{ fontSize: 11, fontWeight: 500, color: '#fff' }}>{l.locataire}</div><div style={{ fontSize: 9, color: '#556' }}>{l.bien}</div></div>



                        <div style={{ textAlign: 'right' }}>



                          <div style={{ fontSize: 12, fontWeight: 600, color: '#C9A84C' }}>{fmtN(l.montant)} F</div>



                          {sBdg(l.statut)}



                        </div>



                      </div>



                    ))



                  }



                </div>



              </div>







              <div className="grid2">



                <div className="card">



                  <div className="card-title">🔹 Alertes ? traiter</div>



                  {impayes === 0 && biens.filter(b => b.statut === 'en_visite').length === 0



                    ? <div style={{ padding: '16px 0', textAlign: 'center', color: '#66bb6a', fontSize: 12 }}>? Aucune alerte</div>



                    : <>



                      {loyers.filter(l => l.statut === 'impaye').map(l => (



                        <div key={l.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, padding: '9px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#ef5350', flexShrink: 0, marginTop: 3 }} />



                          <div><div style={{ fontSize: 11, color: '#ccc' }}><strong>{l.locataire}</strong> ? Loyer impay? ({fmtN(l.montant)} FCFA)</div></div>



                        </div>



                      ))}



                      {biens.filter(b => b.statut === 'en_visite').map(b => (



                        <div key={b.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, padding: '9px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#ff9800', flexShrink: 0, marginTop: 3 }} />



                          <div><div style={{ fontSize: 11, color: '#ccc' }}><strong>{b.titre}</strong> ? Visites en attente</div></div>



                        </div>



                      ))}



                    </>



                  }



                </div>



                <div className="card">



                  <div className="card-title">🔹 R?partition du portefeuille</div>



                  {[...new Set(biens.map(b => b.type))].map(t => {



                    const n = biens.filter(b => b.type === t).length;



                    return (



                      <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>



                        <div style={{ fontSize: 10, color: '#aaa', width: 90 }}>{t}</div>



                        <div style={{ flex: 1 }}><Pbar pct={Math.round(n / biens.length * 100)} color="#1565c0" /></div>



                        <div style={{ fontSize: 10, color: '#64b5f6', fontWeight: 600, width: 16 }}>{n}</div>



                      </div>



                    );



                  })}



                </div>



              </div>



            </div>







            {/* ANNONCES */}



            <div className={`page ${activePage === 'annonces' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Annonces Immobili?res</div><div className="page-sub">{biens.length} biens ? AfricaLocation</div></div>



                <button className="btn-gold" onClick={() => openModal('bien', { type: 'Appartement', meuble: 'non', caution: '2', statut: 'disponible' })}>+ Ajouter un bien</button>



              </div>



              <div style={{ display: 'flex', gap: 7, marginBottom: 14, flexWrap: 'wrap' }}>



                {[{ v: 'tous', l: 'Tous' }, { v: 'disponible', l: '? Disponibles' }, { v: 'loue', l: '🔹 Lou?s' }, { v: 'en_visite', l: '🗑️ En visite' }].map(f => (



                  <button key={f.v} onClick={() => setBienFilter(f.v)} style={{ fontSize: 10, padding: '5px 12px', borderRadius: 99, border: `1.5px solid ${bienFilter === f.v ? '#1565c0' : 'rgba(255,255,255,.07)'}`, background: bienFilter === f.v ? 'rgba(21,101,192,.1)' : 'transparent', color: bienFilter === f.v ? '#90caf9' : '#667', cursor: 'pointer' }}>{f.l}</button>



                ))}



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 14 }}>



                {filteredBiens.map(b => (



                  <div key={b.id} onClick={() => setSelectedBien(b)} style={{ background: '#162535', border: '1px solid rgba(255,255,255,.07)', borderRadius: 11, overflow: 'hidden', cursor: 'pointer' }}>



                    <div style={{ height: 120, background: 'linear-gradient(135deg,rgba(21,101,192,.15),#1c2f42)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 44, position: 'relative' }}>



                      {b.emoji}



                      <div style={{ position: 'absolute', top: 10, left: 10 }}>{sBdg(b.statut)}</div>



                      <div style={{ position: 'absolute', top: 10, right: 10, fontFamily: 'Cormorant Garamond,serif', fontSize: 16, fontWeight: 600, background: 'rgba(0,0,0,.5)', padding: '3px 9px', borderRadius: 20 }}>{fmtN(b.loyer)} F/mois</div>



                    </div>



                    <div style={{ padding: '12px 14px' }}>



                      <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 3 }}>{b.titre}</div>



                      <div style={{ fontSize: 10, color: '#556', marginBottom: 8 }}>🔹 {b.zone}</div>



                      <div style={{ display: 'flex', gap: 10, fontSize: 10, color: '#667', flexWrap: 'wrap', marginBottom: 8 }}>



                        <span>🔹 {b.surface}m?</span><span>🗑️ {b.chambres}</span><span>{b.meuble === 'oui' ? '🔹 Meubl?' : b.meuble === 'semi' ? '🔹 Semi' : '🔹 Non meubl?'}</span>



                      </div>



                      <div style={{ fontSize: 10, color: '#667', marginBottom: 10 }}>🔹 {b.proprio}</div>



                      <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>



                        <button className="btn-outline" style={{ flex: 1, padding: '4px 0', fontSize: 10 }} onClick={() => openModal('bien', { ...b, _isEdit: true })}>🔹 Modifier</button>



                        <button className="btn-outline" style={{ padding: '4px 10px', fontSize: 10, color: '#ef5350' }} onClick={() => setBiens(prev => prev.filter(x => x.id !== b.id))}>🗑️</button>



                      </div>



                    </div>



                  </div>



                ))}



              </div>



            </div>







            {/* PERSONNEL */}



            <div className={`page ${activePage === 'personnel' ? 'active' : ''}`}>



              <PersonnelManagementModule employes={employes} setEmployes={setEmployes} departmentName="Location & Immobilier" heureLimite="08:30" deptId={DEPT_ID} />



            </div>







            {/* PROPRI?TAIRES */}



            <div className={`page ${activePage === 'proprietaires' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Propri?taires</div><div className="page-sub">Mandats de gestion ? AfricaLocation</div></div>



                <button className="btn-gold" onClick={() => openModal('proprio', { commission: '10' })}>+ Nouveau propri?taire</button>



              </div>



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{proprietaires.length}</div><div className="kpi-label">Propri?taires</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{fmtK(proprietaires.reduce((s, p) => s + (p.revenusMensuel || 0), 0))} F</div><div className="kpi-label">Revenus g?r?s/mois</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#66bb6a' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{proprietaires.reduce((s, p) => s + (p.biens || 0), 0)}</div><div className="kpi-label">Biens confi?s</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ff9800' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{fmtK(proprietaires.reduce((s, p) => s + Math.round((p.revenusMensuel || 0) * (p.commission || 10) / 100), 0))} F</div><div className="kpi-label">Commission FHC/mois</div></div>



              </div>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>Propri?taire</th><th>Contact</th><th>Biens confi?s</th><th>Revenus g?r?s</th><th>Commission</th><th>Depuis</th><th>Statut</th><th>Actions</th></tr></thead>



                  <tbody>



                    {proprietaires.map(p => (



                      <tr key={p.id}>



                        <td className="bold">{p.nom}</td>



                        <td><div style={{ fontSize: 11 }}>{p.tel}</div><div style={{ fontSize: 9, color: '#556' }}>{p.email}</div></td>



                        <td style={{ textAlign: 'center' }}><span style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 20, fontWeight: 600, color: '#64b5f6' }}>{p.biens}</span></td>



                        <td className="bold" style={{ color: '#C9A84C' }}>{fmtN(p.revenusMensuel)} FCFA</td>



                        <td><span style={{ color: '#66bb6a', fontWeight: 600 }}>{fmtN(Math.round(p.revenusMensuel * p.commission / 100))} FCFA</span><div style={{ fontSize: 9, color: '#556' }}>{p.commission}%</div></td>



                        <td>{p.depuis}</td>



                        <td>{sBdg(p.statut)}</td>



                        <td style={{ display: 'flex', gap: 4 }}>



                          <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 10 }} onClick={() => openModal('proprio', { ...p, _isEdit: true })}>🔹</button>



                          <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 10, color: '#ef5350' }} onClick={() => setProprietaires(prev => prev.filter(x => x.id !== p.id))}>🗑️</button>



                        </td>



                      </tr>



                    ))}



                  </tbody>



                </table>



              </div>



            </div>







            {/* LOCATAIRES */}



            <div className={`page ${activePage === 'locataires' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Locataires</div><div className="page-sub">Suivi des locataires en cours</div></div>



                <button className="btn-gold" onClick={() => openModal('locataire', {})}>+ Nouveau locataire</button>



              </div>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>Locataire</th><th>Bien lou?</th><th>Loyer</th><th>Caution</th><th>Entr?e</th><th>Fin bail</th><th>Paiement</th><th>Actions</th></tr></thead>



                  <tbody>



                    {locataires.map(l => (



                      <tr key={l.id}>



                        <td className="bold">{l.nom}</td>



                        <td style={{ fontSize: 11 }}>{l.bien}</td>



                        <td className="bold" style={{ color: '#C9A84C' }}>{fmtN(l.loyer)} FCFA</td>



                        <td>{fmtN(l.caution)} FCFA</td>



                        <td>{l.entree}</td>



                        <td>{l.fin}</td>



                        <td>{sBdg(l.statut_paiement)}</td>



                        <td style={{ display: 'flex', gap: 4 }}>



                          <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 10 }} onClick={() => openModal('locataire', { ...l, _isEdit: true })}>🔹</button>



                          <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 10, color: '#ef5350' }} onClick={() => setLocataires(prev => prev.filter(x => x.id !== l.id))}>🗑️</button>



                        </td>



                      </tr>



                    ))}



                  </tbody>



                </table>



              </div>



            </div>







            {/* CONTRATS */}



            <div className={`page ${activePage === 'contrats' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Contrats de Bail</div><div className="page-sub">{contrats.length} contrats actifs</div></div>



                <button className="btn-gold" onClick={() => openModal('contrat', {})}>+ Nouveau contrat</button>



              </div>



              <div className="card">



                {contrats.length === 0



                  ? <div style={{ padding: '20px 0', textAlign: 'center', color: '#445', fontSize: 12 }}>Aucun contrat. Les contrats seront charg?s depuis la BDD.</div>



                  : <table className="tbl">



                    <thead><tr><th>N? Contrat</th><th>Locataire</th><th>Bien</th><th>Propri?taire</th><th>Loyer</th><th>D?but</th><th>Fin</th><th>Statut</th></tr></thead>



                    <tbody>



                      {contrats.map(c => (



                        <tr key={c.num || c.id}>



                          <td className="bold" style={{ color: '#C9A84C', fontSize: 10 }}>{c.num}</td>



                          <td className="bold">{c.locataire}</td>



                          <td style={{ fontSize: 11 }}>{c.bien}</td>



                          <td>{c.proprio}</td>



                          <td className="bold">{fmtN(c.loyer)} FCFA</td>



                          <td>{c.debut}</td>



                          <td>{c.fin}</td>



                          <td>{sBdg(c.statut)}</td>



                        </tr>



                      ))}



                    </tbody>



                  </table>



                }



              </div>



            </div>







            {/* LOYERS */}



            <div className={`page ${activePage === 'loyers' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Loyers & Paiements</div><div className="page-sub">Suivi encaissements</div></div>



                <button className="btn-gold" onClick={() => openModal('paiement', { mode: 'Mobile Money' })}>+ Enregistrer paiement</button>



              </div>



              {(() => {



                const payes = loyers.filter(l => l.statut === 'paye');



                const imp = loyers.filter(l => l.statut === 'impaye');



                const total = payes.reduce((s, l) => s + l.montant, 0);



                return (



                  <>



                    <div className="kpi-grid">



                      <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">?</div><div className="kpi-val" style={{ color: '#66bb6a' }}>{payes.length}</div><div className="kpi-label">Loyers pay?s</div></div>



                      <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ef5350' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#ef8080' }}>{imp.length}</div><div className="kpi-label">Impay?s</div></div>



                      <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#C9A84C' }}>{fmtK(total)} F</div><div className="kpi-label">Total encaiss?</div></div>



                      <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{fmtK(Math.round(total * 0.1))} F</div><div className="kpi-label">Commission FHC (10%)</div></div>



                    </div>



                    <div className="card">



                      <table className="tbl">



                        <thead><tr><th>Locataire</th><th>Bien</th><th>Montant</th><th>Mois</th><th>Date paiement</th><th>Mode</th><th>Statut</th><th>Actions</th></tr></thead>



                        <tbody>



                          {loyers.map(l => (



                            <tr key={l.id}>



                              <td className="bold">{l.locataire}</td>



                              <td style={{ fontSize: 11 }}>{l.bien}</td>



                              <td className="bold" style={{ color: '#C9A84C' }}>{fmtN(l.montant)} FCFA</td>



                              <td>{l.mois}</td>



                              <td>{l.date || '?'}</td>



                              <td>{l.mode}</td>



                              <td>{sBdg(l.statut)}</td>



                              <td>



                                {l.statut === 'impaye' && (



                                  <button className="btn-gold" style={{ fontSize: 9, padding: '3px 9px' }}



                                    onClick={async () => {



                                      try { await api.location.loyers.marquerPaye(l.id, { mode_paiement: 'Esp?ces' }); } catch {}



                                      setLoyers(prev => prev.map(x => x.id === l.id ? { ...x, statut: 'paye', date: new Date().toLocaleDateString('fr-FR') } : x));



                                    }}>? Marquer pay?</button>



                                )}



                              </td>



                            </tr>



                          ))}



                        </tbody>



                      </table>



                    </div>



                  </>



                );



              })()}



            </div>







            {/* STATISTIQUES */}



            <div className={`page ${activePage === 'stats' ? 'active' : ''}`}>



              <div className="page-header"><div><div className="page-title">🔹 Statistiques AfricaLocation</div></div></div>



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#64b5f6' }}>{tauxOcc}%</div><div className="kpi-label">Taux d'occupation</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#66bb6a' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#66bb6a' }}>{disponibles}</div><div className="kpi-label">Biens disponibles</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">🔹</div><div className="kpi-val" style={{ color: '#C9A84C' }}>{fmtK(revenusMois)} F</div><div className="kpi-label">CA location/mois</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ff9800' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{fmtK(Math.round(revenusMois * 0.1))} F</div><div className="kpi-label">Commissions FHC</div></div>



              </div>



              <div className="card">



                <div className="card-title">🔹 R?partition par type</div>



                {[...new Set(biens.map(b => b.type))].map(t => {



                  const n = biens.filter(b => b.type === t).length;



                  return (



                    <div key={t} style={{ marginBottom: 10 }}>



                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>



                        <span style={{ fontSize: 11, color: '#aaa' }}>{t}</span>



                        <span style={{ fontSize: 11, fontWeight: 600, color: '#64b5f6' }}>{n} bien{n > 1 ? 's' : ''}</span>



                      </div>



                      <Pbar pct={biens.length > 0 ? Math.round(n / biens.length * 100) : 0} color="#1565c0" />



                    </div>



                  );



                })}



              </div>



            </div>







            {/* MON ?QUIPE */}



            <div className={`page ${activePage === 'mon-equipe' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">🔹 Mon ?quipe ? Location</div><div className="page-sub">{employes.length} collaborateur(s)</div></div>



                <button className="btn-gold" onClick={() => openModal('employe', { contrat: 'CDI', heureLimite: '08:30', color: '#42a5f5' })}>+ Cr?er un compte</button>



              </div>



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">🔹</div><div className="kpi-val">{employes.length}</div><div className="kpi-label">Collaborateurs</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">?</div><div className="kpi-val" style={{ color: '#66bb6a' }}>{presents}</div><div className="kpi-label">Pr?sents</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ef5350' }} /><div className="kpi-icon">?</div><div className="kpi-val" style={{ color: '#ef8080' }}>{employes.length - presents}</div><div className="kpi-label">Absents</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">?</div><div className="kpi-val" style={{ color: '#C9A84C' }}>{employes.length > 0 ? (employes.reduce((s, e) => s + (e.score || 0), 0) / employes.length).toFixed(1) : '?'}</div><div className="kpi-label">Score moyen</div></div>



              </div>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>Collaborateur</th><th>Poste</th><th>Contrat</th><th>Pr?sence</th><th>T?ches</th><th>Score</th><th>Actions</th></tr></thead>



                  <tbody>



                    {employes.map(e => {



                      const pct = e.tachesQuot > 0 ? Math.round(e.tachesDone / e.tachesQuot * 100) : 0;



                      return (



                        <tr key={e.id}>



                          <td><div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><div style={{ width: 28, height: 28, borderRadius: '50%', background: e.color + '22', color: e.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>{e.av}</div><div><div className="bold">{e.prenom} {e.nom}</div><div style={{ fontSize: 9, color: '#556' }}>Depuis {e.entree}</div></div></div></td>



                          <td>{e.poste}</td>



                          <td>{sBdg(e.contrat)}</td>



                          <td>{e.present ? <span className="badge green">? Pr?sent</span> : <span className="badge red">? Absent</span>}</td>



                          <td style={{ minWidth: 90 }}>{e.tachesQuot > 0 ? <Pbar pct={pct} color={e.color} /> : '?'}</td>



                          <td><span style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 18, fontWeight: 600, color: e.score >= 8 ? '#66bb6a' : e.score >= 6 ? '#C9A84C' : '#ef8080' }}>{e.score || '?'}</span></td>



                          <td style={{ display: 'flex', gap: 4 }}>



                            <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11 }} onClick={() => openModal('employe', { ...e, _isEdit: true })}>🔹</button>



                            <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11, color: '#ef5350' }} onClick={() => setEmployes(prev => prev.filter(x => x.id !== e.id))}>🗑️</button>



                          </td>



                        </tr>



                      );



                    })}



                  </tbody>



                </table>



              </div>



            </div>







            {/* GESTION T?CHES */}



            <div className={`page ${activePage === 'gestion-taches' ? 'active' : ''}`}>



              <div className="page-header"><div><div className="page-title">🔹 Gestion des T?ches</div><div className="page-sub">{totalTasks} t?che{totalTasks !== 1 ? 's' : ''} assign?e{totalTasks !== 1 ? 's' : ''}</div></div></div>



              <PreuvesPanel tasks={tasks} employes={employes} />
              <TaskManagementModule employes={employes} setEmployes={setEmployes} />



            </div>

            {/* PAGE OBJECTIFS */}
            <div className={`page ${activePage === 'objectifs' ? 'active' : ''}`}>

              <div className="page-header"><div><div className="page-title">🎯 Objectifs de l'équipe</div><div className="page-sub">{allObj.length} objectif{allObj.length !== 1 ? 's' : ''}</div></div></div>

              <ObjectifsEmployesModule 
                employes={employes} 
                onRefresh={refetch} 
                isChef={true} 
              />

            </div>

            {/* MA PERFORMANCE */}
            <div className={`page ${activePage === 'ma-performance' ? 'active' : ''}`}>

              <div className="page-header">
                <div>
                  <div className="page-title">⭐ Ma Performance</div>
                  <div className="page-sub">Consultez votre performance personnelle</div>
                </div>
              </div>

              <MaPerformance />

            </div>

            {/* MES TÂCHES */}

            <div className={`page ${activePage === 'taches' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">? Mes T?ches</div><div className="page-sub">{pendingTasks} en attente</div></div>



                <button className="btn-gold" onClick={() => openModal('tache', { prio: 'normale' })}>+ Ajouter</button>



              </div>



              <div className="card">



                {myTasks.length === 0



                  ? <div style={{ padding: '20px 0', textAlign: 'center', color: '#445', fontSize: 12 }}>Aucune t?che.</div>



                  : myTasks.map(t => (



                    <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                      <TaskToggleWithPreuve task={t} onToggle={toggleTask} onToggleWithPreuve={async (id) => { await toggleTask(id); }} />



                      <span style={{ flex: 1, fontSize: 13, color: t.done ? '#445' : '#ccc', textDecoration: t.done ? 'line-through' : 'none' }}>{t.text}</span>



                      <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 99, background: t.prio === 'urgente' ? 'rgba(239,83,80,.15)' : t.prio === 'haute' ? 'rgba(255,152,0,.15)' : 'rgba(66,165,245,.15)', color: t.prio === 'urgente' ? '#ef8080' : t.prio === 'haute' ? '#ffb74d' : '#64b5f6', textTransform: 'uppercase' }}>{t.prio}</span>



                      <button style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 13 }} onClick={() => deleteTask(t.id)}>🗑️</button>



                    </div>



                  ))



                }



              </div>



            </div>







            {/* AGENDA */}



            <div className={`page ${activePage === 'agenda' ? 'active' : ''}`}>



              <div className="page-header"><div><div className="page-title">🔹 Agenda ? Rendez-vous</div><div className="page-sub">Visites ? Signatures ? RDV propri?taires</div></div></div>



              <AgendaSection filterTypes={['client', 'suivi', 'commercial', 'partenariat', 'equipe', 'codir', 'urgente', 'autre']} />



            </div>







            {/* RAPPORTS */}



            <div className={`page ${activePage === 'projets' ? 'active' : ''}`}>



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>



                <div style={{ fontSize: 16, fontWeight: 700 }}>🔹 Projets du d?partement</div>



                <div style={{ fontSize: 11, color: '#94a3b8' }}>{projets.length} projet{projets.length !== 1 ? 's' : ''}</div>



              </div>



              {projets.length === 0 ? (



                <div style={{ textAlign: 'center', padding: 40, color: '#445' }}>Aucun projet assign? ? ce d?partement.</div>



              ) : projets.map(p => {



                const sc = { en_cours: '#42a5f5', planification: '#C9A84C', production: '#ff9800', termine: '#66bb6a', annule: '#ef5350', negociation: '#ab47bc' }[p.status] || '#888';



                const sl = { en_cours: 'En cours', planification: 'Planification', production: 'Production', termine: 'Termin?', annule: 'Annul?', negociation: 'N?gociation' }[p.status] || p.status;



                const av = p.progress || 0;



                return (



                  <div key={p.id} style={{ background: '#162535', borderRadius: 10, padding: 16, marginBottom: 12, border: '1px solid rgba(255,255,255,.06)' }}>



                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>



                      <div>



                        <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{p.name}</div>



                        <div style={{ fontSize: 11, color: '#667' }}>{p.filiale?.nom || '?'}</div>



                      </div>



                      <span style={{ fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 99, background: sc + '22', color: sc }}>{sl}</span>



                    </div>



                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>



                      {[['Budget', p.budget ? Number(p.budget).toLocaleString('fr-FR') + ' FCFA' : '?'], ['Deadline', p.end_date ? new Date(p.end_date).toLocaleDateString('fr-FR') : '?'], ['Chef', p.owner ? (p.owner.prenom + ' ' + (p.owner.nom || '')) : '?']].map(([l, v]) => (



                        <div key={l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '8px 10px' }}>



                          <div style={{ fontSize: 9, color: '#556', marginBottom: 3 }}>{l}</div>



                          <div style={{ fontSize: 11, fontWeight: 600, color: '#ccc' }}>{v}</div>



                        </div>



                      ))}



                    </div>



                    <div style={{ fontSize: 10, color: '#667', marginBottom: 5, display: 'flex', justifyContent: 'space-between' }}>



                      <span>Avancement</span><span style={{ fontWeight: 600 }}>{av}%</span>



                    </div>



                    <div style={{ height: 5, background: 'rgba(255,255,255,.06)', borderRadius: 99 }}>



                      <div style={{ width: av + '%', height: '100%', background: av >= 70 ? '#4caf50' : av >= 40 ? '#ff9800' : '#ef5350', borderRadius: 99 }} />



                    </div>



                  </div>



                );



              })}



            </div>







            <div className={`page ${activePage === 'rapports' ? 'active' : ''}`}>



              <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>



                <h3>🔹 Section Rapports</h3>



                <p>Disponible prochainement.</p>



              </div>



            </div>







          </div>{/* /main */}



        </div>{/* /layout */}







        {/* MODALS */}



        {modal === 'bien' && (



          <ModalWrap title={form._isEdit ? 'Modifier le bien' : '?? Ajouter un bien'} onSave={saveBien} onClose={closeModal}>



            <F label={"Titre de l'annonce *"} name="titre" />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Type *" name="type" opts={['Appartement', 'Maison', 'Studio', 'Bureau', 'Commerce', 'Villa', 'Terrain']} />



              <F label="Zone / Quartier *" name="zone" />



              <F label="Loyer mensuel (FCFA) *" name="loyer" type="number" />



              <F label="Caution (mois)" name="caution" opts={[{ v: '1', l: '1 mois' }, { v: '2', l: '2 mois' }, { v: '3', l: '3 mois' }]} />



              <F label="Surface (m?)" name="surface" type="number" />



              <F label="Chambres" name="chambres" opts={['Studio', 'F1', 'F2', 'F3', 'F4', 'F5+']} />



              <F label="Meubl?" name="meuble" opts={[{ v: 'oui', l: 'Oui' }, { v: 'non', l: 'Non' }, { v: 'semi', l: 'Semi-meubl?' }]} />



              <F label="Statut" name="statut" opts={[{ v: 'disponible', l: '? Disponible' }, { v: 'loue', l: '🔹 Lou?' }, { v: 'en_visite', l: '🗑️ En visite' }]} />



            </div>



            <F label="Propri?taire" name="proprio" />



            <F label="Description" name="desc" rows={2} />



          </ModalWrap>



        )}



        {modal === 'proprio' && (



          <ModalWrap title={form._isEdit ? 'Modifier le propri?taire' : '🔹 Nouveau propri?taire'} onSave={saveProprio} onClose={closeModal}>



            <F label="Nom complet *" name="nom" />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="T?l?phone" name="tel" />



              <F label="Email" name="email" type="email" />



              <F label="Commission FHC (%)" name="commission" opts={[{ v: '8', l: '8%' }, { v: '10', l: '10%' }, { v: '12', l: '12%' }]} />



            </div>



          </ModalWrap>



        )}



        {modal === 'locataire' && (



          <ModalWrap title={form._isEdit ? 'Modifier le locataire' : '🔹 Nouveau locataire'} onSave={saveLocataire} onClose={closeModal}>



            <F label="Nom complet *" name="nom" />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="T?l?phone" name="tel" />



              <F label="Bien lou?" name="bien" opts={biens.map(b => ({ v: b.titre, l: b.titre }))} />



              <F label="Loyer mensuel (FCFA)" name="loyer" type="number" />



              <F label="Caution vers?e (FCFA)" name="caution" type="number" />



              <F label="Date d'entr?e" name="entree" type="date" />



              <F label="Fin de bail" name="fin" type="date" />



            </div>



          </ModalWrap>



        )}



        {modal === 'contrat' && (



          <ModalWrap title="🔹 Nouveau contrat de bail" onSave={() => {



            if (!form.locataire) return;



            setContrats(prev => [...prev, { num: `BAIL-${new Date().getFullYear()}-${String(prev.length + 1).padStart(3, '0')}`, locataire: form.locataire, bien: form.bien || '?', proprio: form.proprio || '?', loyer: parseFloat(form.loyer) || 0, debut: form.debut || TODAY, fin: form.fin || '?', caution: parseFloat(form.caution) || 0, statut: 'actif' }]);



            closeModal();



          }} onClose={closeModal}>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Locataire *" name="locataire" opts={locataires.map(l => ({ v: l.nom, l: l.nom }))} />



              <F label="Bien" name="bien" opts={biens.map(b => ({ v: b.titre, l: b.titre }))} />



              <F label="Propri?taire" name="proprio" />



              <F label="Loyer mensuel (FCFA)" name="loyer" type="number" />



              <F label="Date de d?but" name="debut" type="date" />



              <F label="Date de fin" name="fin" type="date" />



              <F label="Caution (FCFA)" name="caution" type="number" />



            </div>



          </ModalWrap>



        )}



        {modal === 'paiement' && (



          <ModalWrap title="🔹 Enregistrer un paiement" onSave={savePaiement} onClose={closeModal}>



            <F label="Locataire *" name="locataire" opts={locataires.map(l => ({ v: l.nom, l: l.nom }))} />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Mois concern?" name="mois" opts={[moisActuel, 'Mois pr?c?dent', 'Mois suivant']} />



              <F label="Mode de paiement" name="mode" opts={['Mobile Money', 'Virement', 'Esp?ces', 'Ch?que']} />



            </div>



            <F label="Montant re?u (FCFA) *" name="montant" type="number" />



          </ModalWrap>



        )}



        {modal === 'employe' && (



          <ModalWrap title={form._isEdit ? 'Modifier le collaborateur' : '?? Cr?er un compte'} onSave={saveEmploye} onClose={closeModal}>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Pr?nom *" name="prenom" />



              <F label="Nom *" name="nom" />



            </div>



            <F label="Poste" name="poste" />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Email" name="email" type="email" />



              <F label="Mot de passe" name="password" type="password" />



            </div>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Filiale" name="filiale" opts={['FHC Groupe SARL', 'FHC Conseil', 'FHC Technologie', 'FHC Formation', 'FHC Location', 'EMPLOI+']} />



              <F label="Contrat" name="contrat" opts={['CDI', 'CDD', 'Stage']} />



            </div>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>



              <F label="Heure limite" name="heureLimite" type="time" />



              <F label="Couleur (ex: #42a5f5)" name="color" />



            </div>



            <F label="Date d'entr?e (ex: Juin 2026)" name="entree" />



          </ModalWrap>



        )}



        {modal === 'tache' && (



          <ModalWrap title="Nouvelle t?che" onSave={saveTask} onClose={closeModal}>



            <F label="T?che *" name="text" />



            <F label="Priorit?" name="prio" opts={[{ v: 'urgente', l: '🔹 Urgente' }, { v: 'haute', l: '🔹 Haute' }, { v: 'normale', l: '🔹 Normale' }]} />



          </ModalWrap>



        )}







        {/* DETAIL BIEN */}



        {selectedBien && (



          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 900, display: 'flex', justifyContent: 'flex-end' }} onClick={() => setSelectedBien(null)}>



            <div style={{ width: 420, maxWidth: '95vw', height: '100vh', background: '#0d1b2a', borderLeft: '1px solid rgba(255,255,255,.1)', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



              <div style={{ position: 'sticky', top: 0, background: '#0d1b2a', borderBottom: '1px solid rgba(255,255,255,.07)', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>



                <span style={{ fontSize: 13, fontWeight: 600, color: '#90caf9' }}>{selectedBien.titre}</span>



                <button onClick={() => setSelectedBien(null)} style={{ background: 'none', border: 'none', color: '#667', fontSize: 18, cursor: 'pointer' }}>?</button>



              </div>



              <div style={{ padding: '18px 18px 40px' }}>



                <div style={{ height: 120, background: 'linear-gradient(135deg,rgba(21,101,192,.2),#1c2f42)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 54, marginBottom: 16 }}>{selectedBien.emoji}</div>



                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>{sBdg(selectedBien.statut)}</div>



                {[['🔹 Zone', selectedBien.zone], ['🔹 Surface', selectedBien.surface + 'm?'], ['🗑️ Chambres', selectedBien.chambres], ['🔹 Loyer', fmtN(selectedBien.loyer) + ' FCFA/mois'], ['🔹 Propri?taire', selectedBien.proprio]].map(([l, v]) => (



                  <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                    <span style={{ fontSize: 11, color: '#667' }}>{l}</span>



                    <span style={{ fontSize: 11, fontWeight: 500, color: '#fff' }}>{v}</span>



                  </div>



                ))}



                <div style={{ marginTop: 12, fontSize: 11, color: '#aaa', padding: 10, background: 'rgba(255,255,255,.02)', borderRadius: 7, lineHeight: 1.5 }}>{selectedBien.desc}</div>



                {selectedBien.locataire && <div style={{ marginTop: 10, padding: '10px 12px', background: 'rgba(67,160,71,.08)', border: '1px solid rgba(67,160,71,.2)', borderRadius: 7, fontSize: 11, color: '#66bb6a' }}>🔹 Occup? par : <strong>{selectedBien.locataire}</strong></div>}



                <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>



                  <button className="btn-gold" style={{ flex: 1, fontSize: 11 }} onClick={() => { openModal('bien', { ...selectedBien, _isEdit: true }); setSelectedBien(null); }}>🔹 Modifier</button>



                  <button className="btn-outline" style={{ fontSize: 11 }} onClick={() => setSelectedBien(null)}>Fermer</button>



                </div>



              </div>



            </div>



          </div>



        )}







      </div>



    </MainLayout>



  );



}







export default DashboardLocationPage;





